<script setup>
import SquareIconButton from "@/components/global-themed/buttons/SquareIconButton.vue";
import {computed} from "vue";
import useWebsite from "@/composables/useWebsite";
import {useStore} from "vuex";

const store = useStore();
const { refetchWebsite } = useWebsite();
const selectedCompetitor = computed(() => store.getters['competitionV2/competitor']);
const auditRefreshing = computed(() => store.getters['competitionV2/competitorAuditRefreshing']);

const refreshCompetitor = () => {
  store.dispatch('competitionV2/refreshCompetitorAudit', selectedCompetitor.value.id).then(() => {
    refetchWebsite();
    open.value = false;
  })
}
</script>

<template>
  <SquareIconButton
    variant="primary-inverted"
    size="small"
    :disabled="auditRefreshing"
    @click="refreshCompetitor"
  >
    <svg-vue
      icon="icons/refresh"
      :class="[
        'tw-w-6 tw-h-6 tw-text-blue',
        {'tw-animate-spin' : auditRefreshing},
      ]"
    />
  </SquareIconButton>
</template>
